<template>
  <validation-observer ref="simpleRules">
    <purchase-offers-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import PurchaseOffersItemForm from '@/views/Admin/Purchase_offers/Components/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    PurchaseOffersItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
    saveData() {
      return this.$store.getters['purchaseOffers/dataSaveStatus']
    },
    itemList() {
      return this.$store.getters['purchaseOfferItems/dataList']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/app/purchase-offers')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('purchaseOffers/getDataItem', { id: this.$route.params.id })
        .then(res => {
          if (res) {
            this.$store.dispatch('purchaseOfferItems/getDataList', {
              where: {
                'purchase_offer_items.id_purchase_offers': res.id,
              },
            })
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          if (this.itemList.length > 0) {
            this.itemData.items = this.itemList
          }
          this.$store.dispatch('purchaseOffers/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
